<!--
 * @Description: 综合绩效管理-员工考核表列表
 * @Author: maqinghe 
 * @Date: 2023年06月27日 13:10:20
-->
<template>
  <div class='month-manage atb-flex atb-flex-column'>
    <div class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native="getList('resetPage')" @submit.native.prevent>
          <el-form-item label="年份">
            <el-date-picker v-model="searchParam.Year" type="year" format="yyyy 年" value-format="yyyy" placeholder="选择年份"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList('resetPage')">查询</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="export" @click="exportExcel">导出</el-button>
          </el-form-item> -->
        </el-form>
      </div>
      <div class='table-content atb-flex atb-flex-column'>
        <vxe-table
          class='atb-table header-table edit-table'
          stripe
          border='inner'
          height='100%'
          auto-resize
          resizable
          highlight-hover-row
          :data="tableData"
          ref="table"
          :edit-config="{trigger: 'manual', mode: 'row'}"
          @cell-dblclick="goDetail"
          @cell-click="expandRow"
        >
          <vxe-table-column type="seq" width="50" title="NO."></vxe-table-column>
          <vxe-table-column field="department" title="部门" min-width="220" ></vxe-table-column>
          <vxe-table-column field="wkNo" title="工号" width="100"></vxe-table-column>
          <vxe-table-column field="wkName" title="姓名" width="100"></vxe-table-column>
          <vxe-table-column field="period" title="期次" width="100">
            <template #default="{ row }">
              <span class="table-link" @click.stop='goDetail({row})'>{{ row.year }}{{ periods[row.period] }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="category" title="类型" width="150">
            <template #default="{row}">
              <span v-if="row.category==='Year'">年计划考核</span>
              <span v-if="row.category==='Month'">员工绩效考核</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="commitDate" title="评分时间" width="100">
            <template #edit="{ row }">
              <el-date-picker v-model="row.commitDate" type="date" value-format="yyyy/MM/dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{row.commitDate ? new Date(row.commitDate).toLocaleDateString() : ''}}</template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" width="90">
            <template #default="{ row }">
              <template v-if="row.category === 'Month'">
                <el-tag v-if="row.status === 0 || row.status === 20 || row.status === 30 || row.status === 40 || row.status === 50" type="complete" effect="dark">
                  {{ statusMap[row.status] || '' }}
                </el-tag>
                <el-tag v-if="row.status === 10" type="close" effect="dark">
                  {{ statusMap[row.status] || '' }}
                </el-tag>
              </template>

              <template v-else-if="row.category === 'Year'">
                <el-tag type="complete" effect="dark">
                  {{ yearStatusMap[row.status] || '' }}
                </el-tag>
              </template>
            </template>
          </vxe-table-column>
          <vxe-table-column field="approveReason" title="审批意见" min-width="150">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.approveReason || '无' }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" class-name='operation' width="100">
            <template #default="scope">
              <el-tooltip class='item' effect='dark' content='编辑' placement="bottom">
                <i class='icon-editor' @click.stop='goDetail({row: scope.row})'></i>
              </el-tooltip>
              <el-tooltip class='item' effect='dark' content='删除' placement="bottom">
                <i class='icon-close delete' @click.stop='deleteTip(scope.row)'></i>
              </el-tooltip>
            </template>
          </vxe-table-column>
        </vxe-table>

      </div>
       <div class='page-con atb-flex atb-flex-justify-end'>
          <vxe-pager
            background
            :current-page.sync="page.PageIndex"
            :page-size.sync="page.PageSize"
            :total="total"
            height="100%"
            @page-change="handlePageChange"
            :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
          >
          </vxe-pager>
        </div>
    </div>
    
    <el-dialog title="提示" :visible.sync="showDelTip" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定要删除吗</h2>
        <p>此操作会删除对应的工作项</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="del">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showDelTip = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import {
    PERIODS,
    PERIOD_LIST,
    WORK_SCORE,
    YEAR_PLAN_STATUS
  } from '@/utils/period-enum.js';
  import routeMixin from '@/mixins/route.mixin';
  import workscoreMixin from '@/mixins/workscore.mixin.js';

  export default {
    name: "ManageWorkscoreList",
    mixins: [routeMixin, workscoreMixin],
    data() {
      return {
        currWkNo: '',
        periods: PERIODS,
        periodList: PERIOD_LIST,
        wkNo: '',
        searchParam: {
          Year: undefined,
        },
     
        page: {
          PageIndex: 1,
          PageSize: 10
        },
        total: 0,
        tableData: [],
    
        statusMap: WORK_SCORE,
        yearStatusMap: YEAR_PLAN_STATUS,

        showDelTip: false,
        row: {},

        isShowAdd: false,
        isDynamicEffective: true, // 是否启用动态版本
      }
    },
    computed: {},
    created() {
      const userInfo = sessionStorage.getItem('userInfo');
      this.currWkNo = userInfo ? JSON.parse(userInfo).wkNo : '';

      this.getDynamicClassify({});
      this.wkNo = this.$route.query.wkNo || '';
      this.getList();
    },
    methods: {
      getList(resetPage) {
        if(resetPage){
          this.page.PageIndex = 1;
        }
        let param = Object.assign({LoginWkNo: this.wkNo || this.currWkNo, Year: this.searchParam.Year || undefined}, this.page)
        this.$ajax.get(this.$api.period.workScore.list, param).then((res) => {
          this.tableData = res.data.rows;
          this.total = res.data.total;
        });
      },

      deleteTip(row) {
        this.showDelTip = true;
        this.row = row;
      },
      del() {
        if (this.row) {
          let fn = Promise.resolve();
          if (this.row.category === 'Month') {
            fn = this.$ajax.delete(this.$api.period.manage.listDelete + '/' + this.row.id);
          } else if (this.row.category === 'Year') {
            fn = this.$ajax.get(this.$api.period.manage.deleteYearScore + '?id=' + this.row.id);
          }
          fn.then(() => {
            this.$message.success('删除成功');
            this.getList();
          }).finally(() => {
            this.showDelTip = false;
         });
        }
      },

      handlePageChange({currentPage}) {
        this.page.PageIndex = currentPage;
        this.getList();
      },
      exportExcel() {
        let param = Object.assign({}, this.searchParam,{departmentNo:this.departmentNo});
        this.$ajax.get(this.$api.export.OecManagementListExport, param, {ignore: true, responseType: 'blob'}).then((res) => {
          if (res.data.type == 'application/json') {
            var reader = new FileReader();
            reader.onload = () => {
              var content = reader.result;//内容就在这里
              let json = JSON.parse(content)
              this.$message.error(json.message)
            };
            reader.readAsText(res.data);
          } else {
            const filename = 'OEC管理'
            const filetype = 'xlsx'
            let data = res.data;
            let url = window.URL.createObjectURL(data)
            let a = document.createElement('a')
            document.body.appendChild(a)
            a.href = url
            a.download = filename + '.' + filetype
            a.click()
            window.URL.revokeObjectURL(url)
          }
        });
      },
      goDetail({row}) {
        if (row.category === 'Month') {
          this.$router.push({
            path: '/period/manage/workscore',
            query:{
              id: row.id,
            }
          });
        } else if (row.category === 'Year') {
          let pagePath = '/period/manage/yearWorkscore';
          if (this.isDynamicEffective && row.versionId) {
            pagePath = '/period/manage/yearWorkScoreNext';
          }
          this.$router.push({path: pagePath, query: { id: row.id }});
        }
      },
      expandRow({row}) {
        row.expandRowFlag = !row.expandRowFlag;
        let $table = this.$refs.table;
        $table.updateData(this.tableData);
      },
    },
  }
</script>
<style scoped lang='scss'>
  .month-manage {
    height: 100%;
    .atb-content-bg {
      flex: 1;
    }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
    }
    ::v-deep .el-input-group__append {
      padding: 0 5px;
    }
  }
  .footer {
    text-align: right;
    margin-top: 20px;
    .select-all-program {
      margin-right: 20px;
    }
  }

</style>